import React from 'react';
import StaticPageLayout, { StaticSection } from '../components/StaticPageLayout.jsx';

export default function PrivacyPolicyPage() {
  return (
    <StaticPageLayout
      eyebrow="Confidentialité"
      title="Politique de confidentialité"
      description="Cette page résume, de façon simple, les principales règles appliquées au traitement des données utilisées par Paye ta charge mentale !"
      lastUpdated="Mars 2026"
    >
      <StaticSection title="1. Données concernées">
        <p>
          L'application traite les informations que vous fournissez directement lors de
          l'utilisation du service, par exemple votre prénom ou surnom, le nom du foyer, vos
          réponses au questionnaire, certaines informations de contexte sur votre foyer, et
          éventuellement votre adresse email de récupération si vous choisissez d'en ajouter une.
        </p>
      </StaticSection>

      <StaticSection title="2. Finalités du traitement">
        <p>
          Ces informations sont utilisées pour faire fonctionner l'application, enregistrer votre
          progression, afficher vos résultats, comparer les réponses entre membres d'un même foyer,
          et permettre la reconnexion ou la récupération d'accès lorsque cette fonctionnalité est
          activée.
        </p>
      </StaticSection>

      <StaticSection title="3. Partage et confidentialité">
        <p>
          Les données ne sont pas revendues. Elles sont utilisées uniquement pour l'exploitation du
          service, son amélioration, la maintenance technique, et la production éventuelle de
          statistiques agrégées ne permettant pas d'identifier directement une personne.
        </p>
      </StaticSection>

      <StaticSection title="4. Conservation et sécurité">
        <p>
          Les données sont conservées pendant la durée nécessaire au fonctionnement du service et à
          la gestion de votre accès. Des mesures raisonnables de sécurité sont mises en place pour
          limiter les accès non autorisés, la perte, l'altération ou la divulgation des données.
        </p>
      </StaticSection>

      <StaticSection title="5. Vos choix">
        <p>
          Vous pouvez limiter les informations facultatives que vous renseignez dans l'application.
          Si vous souhaitez demander la suppression de vos données ou obtenir une assistance sur ce
          sujet, utilisez le canal de support associé au service.
        </p>
      </StaticSection>

      <StaticSection title="6. Mesure d'audience et fonctionnement technique">
        <p>
          Des informations techniques minimales, comme des données de navigation ou des journaux
          applicatifs, peuvent être utilisées pour améliorer la stabilité du service, comprendre
          son usage global et corriger les incidents.
        </p>
      </StaticSection>
    </StaticPageLayout>
  );
}
